import { FacebookCircleColorIcon } from '~/components/icons/generated/FacebookCircleColorIcon'
import { LineCircleColorIcon } from '~/components/icons/generated/LineCircleColorIcon'
import { XCircleColorIcon } from '~/components/icons/generated/XCircleColorIcon'

type Props = {
  twitterShareUrl?: string
  facebookShareUrl?: string
  lineShareUrl?: string
}

export const ShareButtons: React.FC<Props> = ({
  twitterShareUrl,
  facebookShareUrl,
  lineShareUrl,
}) => {
  if (!twitterShareUrl && !facebookShareUrl && !lineShareUrl) return null
  return (
    <div className="flex justify-center">
      {twitterShareUrl && (
        <a
          href={twitterShareUrl}
          target="_blank"
          rel="noreferrer"
          className="p-2"
          aria-label="Xでシェア"
        >
          <XCircleColorIcon
            className="h-[27px] hover:opacity-70"
            title="X"
            aria-hidden
          />
        </a>
      )}
      {facebookShareUrl && (
        <a
          href={facebookShareUrl}
          target="_blank"
          rel="noreferrer"
          className="px-[6px] py-2"
          aria-label="Facebookでシェア"
        >
          <FacebookCircleColorIcon
            className="h-[27px] xl:hover:opacity-70"
            title="Facebook"
            aria-hidden
          />
        </a>
      )}
      {lineShareUrl && (
        <a
          href={lineShareUrl}
          target="_blank"
          rel="noreferrer"
          className="p-2 xl:hidden"
          aria-label="LINEでシェア"
        >
          <LineCircleColorIcon
            className="size-[27px]"
            title="LINE"
            aria-hidden
          />
        </a>
      )}
    </div>
  )
}
